var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AspectContentScoped } from './AspectContentScoped';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { AspectContentLocal } from './AspectContentLocal';
export class AspectContent {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get aspect() {
        return this.parent;
    }
    get global() {
        return new AspectContentScoped(this, this.aspect.global);
    }
    get regional() {
        return new AspectContentScoped(this, this.aspect.regional);
    }
    get local() {
        return new AspectContentLocal(this);
    }
}
__decorate([
    memoize
], AspectContent.prototype, "global", null);
__decorate([
    memoize
], AspectContent.prototype, "regional", null);
__decorate([
    memoize
], AspectContent.prototype, "local", null);
